var map = {
	"./sticker_cute_number_0.png": 6893,
	"./sticker_cute_number_1.png": 3131,
	"./sticker_cute_number_2.png": 3669,
	"./sticker_cute_number_3.png": 4358,
	"./sticker_cute_number_4.png": 3375,
	"./sticker_cute_number_5.png": 6339,
	"./sticker_cute_number_6.png": 1738,
	"./sticker_cute_number_7.png": 2014,
	"./sticker_cute_number_8.png": 2097,
	"./sticker_cute_number_9.png": 2394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4415;